<template src="./home.html"></template>

<script>

import Timbratura from './Timbrature/Timbratura.vue';
import GeneratoreQR from './Manager/GeneratoreQR.vue';

export default {

  components: { Timbratura, GeneratoreQR },

  data: () => ({
  }),

  computed: {
    username() {
      return this.$store.getters["user/getNome"];
    },

    role() {
      return this.$store.getters["user/getRole"];
    },
  },

  methods: {
    async init() {
      let resUpdate = await this.$i2kFunctions.checkUpdate(
        this.$load.getUrlUpdate()
      );

      if (resUpdate) this.$toast.update("E' disponibile una nuova versione");
    },
  },

  mounted() {
    this.init();

    // Sicurezza: se atterro sulla home ma sono in modalità desktop, vado al calendario
    if (this.$route.query.view === 'desktop') {
      this.$router.push('/calendario?view=desktop');
    }
  },
};
</script>
